export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: that.disabled ? 80 : 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_fileName') || '文档名称',
    field: 'fileName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 280,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('table_label_uploadByName') || '上传人',
    field: 'uploadByName',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'uploadByName',
    },
  },
]
